/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({

  //custom template
  work_steps: {},
  defect_steps: {},
  quality_steps: {},
  logistic_steps: {},
  design_steps: {},

  //custom workpackage
  wwork_steps: {},
  wdefect_steps: {},
  wquality_steps: {},
  wlogistic_steps: {},
  wdesign_steps: {},

  //custom sequence
  swork_steps: {},
  sdefect_steps: {},
  squality_steps: {},
  slogistic_steps: {},
  sdesign_steps: {},

  //community template
  cwork_steps: {},
  cdefect_steps: {},
  cquality_steps: {},
  clogistic_steps: {},
  cdesign_steps: {},

  //community workpackage
  cwwork_steps: {},
  cwdefect_steps: {},
  cwquality_steps: {},
  cwlogistic_steps: {},
  cwdesign_steps: {},

  //community sequence
  cswork_steps: {},
  csdefect_steps: {},
  csquality_steps: {},
  cslogistic_steps: {},
  csdesign_steps: {},

  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getSteps: ( state ) => ( type ) => {
    return state[`${type}_steps`];
  },
  getStepById: ( state ) => (payload) => {
    return state[`${payload.type}_steps`][payload.id];
  },
  getUrl: () => ( payload ) => {
    if (['work', 'defect', 'quality', 'logistic', 'design'].includes(payload.type)) {
      return `${payload.type}steps`;
    } else if (['wwork', 'wdefect', 'wquality', 'wlogistic', 'wdesign'].includes(payload.type)) {
      return `workpackages/${payload.work_package_id}/${payload.type}steps`;
    } else if (['swork', 'sdefect', 'squality', 'slogistic', 'sdesign'].includes(payload.type)) {
      return `sequences/${payload.sequence_id}/swaggons/${payload.waggon_id}/sworkpackages/${payload.work_package_id}/${payload.type}steps`;
    } else if (['cwork', 'cdefect', 'cquality', 'clogistic', 'cdesign'].includes(payload.type)) {
      return `community/${payload.type}steps`;
    }
  }
};

// Actions
const actions = {
  requestSteps({ commit, getters }, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'GET',
        headers: {'Cache-Control': 'no-cache'}
      })
      .then(resp => {
        payload.resp_data = resp.data.data;
        commit('create_steps', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  createStep({commit, getters}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: getters.getUrl(payload),
        method: 'POST',
        data: payload.step
      })
      .then(resp => {
        payload.resp_data = [resp.data.data];
        commit('create_steps', payload);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject();
      });
    });
  },
  updateStep({commit, getters}, payload){
    axios({
      url: getters.getUrl(payload) + '/' + payload.step_id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_step', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteStep({commit, getters}, payload){
    axios({
      url: getters.getUrl(payload) + '/' + payload.step_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('delete_step', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
};

// Mutations
const mutations = {
  create_steps(state, payload) {
    payload.resp_data.forEach(step =>
      Vue.set(state[`${payload.type}_steps`], step.id, step)
    );
  },
  update_step(state, payload){
    Object.assign(state[`${payload.type}_steps`][payload.step_id], payload.update);
  },
  delete_step(state, payload) {
    Vue.delete(state[`${payload.type}_steps`], payload.step_id);
  },
  set_error(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
